import { useState } from 'react';
import { getTitle } from '../../scripts/Editor/utils/sceneutils';

// Detached display order only. Scene objects, screenplay order and day entries are never edited.
export const screenplayLocation = scene => String(scene.location || getTitle(scene.heading).title || 'Unknown location').trim().replace(/\s+/g, ' ').toUpperCase();
export const locationGroups = (scenes, order = []) => {
  const groups = new Map();
  scenes.forEach(scene => {
    const key = screenplayLocation(scene);
    if (!groups.has(key)) groups.set(key, { key, label: key, scenes: [] });
    groups.get(key).scenes.push(scene);
  });
  const keys = [...order.filter(key => groups.has(key)), ...[...groups.keys()].filter(key => !order.includes(key))];
  return keys.map(key => groups.get(key));
};
export const moveLocationGroup = (order, key, direction) => {
  const from = order.indexOf(key), to = from + direction;
  if (from < 0 || to < 0 || to >= order.length) return order;
  const next = [...order];
  next.splice(from, 1); next.splice(to, 0, key);
  return next;
};
export function useUnscheduledLocationGroups(scenes) {
  const [grouped, setGrouped] = useState(false), [order, setOrder] = useState([]);
  const groups = locationGroups(scenes, order);
  // Retain temporarily absent groups (search/assignment) in their chosen slots.
  const move = (key, direction) => {
    const fullOrder = [...order, ...groups.map(g => g.key).filter(k => !order.includes(k))];
    const visible = groups.map(g => g.key), moved = moveLocationGroup(visible, key, direction);
    let index = 0;
    setOrder(fullOrder.map(k => visible.includes(k) ? moved[index++] : k));
  };
  return { grouped, setGrouped, groups, move, displayScenes: grouped ? groups.flatMap(g => g.scenes) : scenes };
}